/** The home-screen icon (the signature HTML and role round, 2026-10-28; brief rule 7): iOS's "Add to Home Screen" reads the page's touch icon
 *  link at that moment, so a workspace with a logo points it at its own icon (`/_logo/<ws>/touch.png?v=<logo file>`, made by the API) and
 *  every other page keeps the default from index.html. The web-app title is always "OmnaBase" (index.html). */

/** the workspace's touch icon address for its logo's public path (`/_logo/<ws>/<file>`), or null without a logo */
export function touchIconHref(logoPath: string | null | undefined): string | null {
  const m = logoPath ? /^(\/_logo\/[^/]+)\/([^/?]+)$/.exec(logoPath) : null;
  return m ? `${m[1]}/touch.png?v=${encodeURIComponent(m[2]!)}` : null;
}

let defaultHref: string | null = null;
/** the head's touch icon link follows the loaded workspace: its own icon with a logo, else the default */
export function applyTouchIcon(logoPath: string | null | undefined, doc: Document = document): void {
  const link = doc.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
  if (!link) return;
  defaultHref ??= link.getAttribute("href");
  const href = touchIconHref(logoPath) ?? defaultHref;
  if (href && link.getAttribute("href") !== href) link.setAttribute("href", href);
}
